var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ButtonBase, makeStyles } from '@material-ui/core';
import { SpellIcon, useWithSound } from '@timeflies/app-ui';
import React from 'react';
var useStyles = makeStyles(function (_a) {
    var transitions = _a.transitions;
    return ({
        root: function (_a) {
            var selected = _a.selected, clickable = _a.clickable;
            var commonStyles = {
                transition: transitions.create(['opacity', 'filter'], {
                    duration: transitions.duration.shortest
                }),
            };
            if (selected) {
                return __assign(__assign({}, commonStyles), { filter: 'brightness(2)' });
            }
            if (!clickable) {
                return {
                    cursor: 'default'
                };
            }
            return (__assign(__assign({}, commonStyles), { '&:hover': {
                    filter: 'brightness(1.5)'
                } }));
        }
    });
});
export var SpellButtonSimple = function (_a) {
    var spellRole = _a.spellRole, imageSize = _a.imageSize, selected = _a.selected, disabled = _a.disabled, padding = _a.padding, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave;
    var classes = useStyles({ selected: selected, clickable: !!onClick });
    var withSound = useWithSound('buttonClick');
    return (React.createElement(ButtonBase, { className: classes.root, onClick: withSound(onClick), onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerDown: onMouseEnter, onPointerUp: onMouseLeave, disabled: disabled },
        React.createElement(SpellIcon, { size: imageSize, spellRole: spellRole, padding: padding })));
};
